<template>
    <div>
        <slot :lettersActive="lettersActive" :alphabets="alphabets" :letters="letters"></slot>
    </div>
</template>

<script>
import { defineComponent, ref, watch, inject} from 'vue';
import { uniq } from 'lodash';

export default defineComponent({
    name: 'OrchestraRoster',
    props: {
        block: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const block = ref({});
        const lettersActive = ref([]);
        const letters = ref([]);

        const letterGroup = ref({
            "A": {
                title: "A",
                participantGroup: []
            },
            "B": {
                title: "B",
                participantGroup: []
            },
            "C": {
                title: "C",
                participantGroup: []
            },
            "D": {
                title: "D",
                participantGroup: []
            },
            "E": {
                title: "E",
                participantGroup: []
            },
            "F": {
                title: "F",
                participantGroup: []
            },
            "G": {
                title: "G",
                participantGroup: []
            },
            "H": {
                title: "H",
                participantGroup: []
            },
            "I": {
                title: "I",
                participantGroup: []
            },
            "J": {
                title: "J",
                participantGroup: []
            },
            "K": {
                title: "K",
                participantGroup: []
            },
            "L": {
                title: "L",
                participantGroup: []
            },
            "M": {
                title: "M",
                participantGroup: []
            },
            "N": {
                title: "N",
                participantGroup: []
            },
            "O": {
                title: "O",
                participantGroup: []
            },
            "P": {
                title: "P",
                participantGroup: []
            },
            "Q": {
                title: "Q",
                participantGroup: []
            },
            "R": {
                title: "R",
                participantGroup: []
            },
            "S": {
                title: "S",
                participantGroup: []
            },
            "T": {
                title: "T",
                participantGroup: []
            },
            "U": {
                title: "U",
                participantGroup: []
            },
            "V": {
                title: "V",
                participantGroup: []
            },
            "W": {
                title: "W",
                participantGroup: []
            },
            "X": {
                title: "X",
                participantGroup: []
            },
            "Y": {
                title: "Y",
                participantGroup: []
            },
            "Z": {
                title: "Z",
                participantGroup: []
            }
        });

        const alphabets = Object.keys(letterGroup.value);

        watch(
            () => props.block,
            (newBlock) => {
                block.value = newBlock;
                console.log('Groups', newBlock.groups)
                newBlock?.groups.forEach(group => {
                    group.instruments.forEach(instrument => {
                        if (Object.keys(instrument).length) {
                            instrument.participantGroup.forEach(particGroup => {
                                letterGroup.value[particGroup.lastName.trim().toUpperCase()[0]].participantGroup.push(particGroup)
                            })
                        }
                    })
                });

                Object.values(letterGroup.value).forEach(letter => {
                    lettersActive.value.push(letter);

                    if (letter.participantGroup.length > 0) {
                        letters.value.push(letter.title.toUpperCase())
                    }
                })

                console.log('BLOCK: ', newBlock);
                console.log('Letters Active: ', lettersActive.value);
            },
            { immediate: true }
        );

        return {
            lettersActive,
            alphabets,
            letters
        }
    }
});
</script>


